module.exports = __webpack_public_path__ + "static/level-9-card.10c70a38.png";